import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    makeStyles,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField
} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        minWidth: 400,
        padding: theme.spacing(2)
    },
    formControl: {
        marginTop: theme.spacing(2),
        minWidth: '100%'
    },
    textField: {
        marginTop: theme.spacing(2),
        width: '100%'
    },
    datePickerContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2)
    }
}));

export default function DeleteScheduleDialog({ open, onClose, onConfirm }) {
    const classes = useStyles();
    const [reason, setReason] = React.useState('');
    const [customReason, setCustomReason] = React.useState('');
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    const handleReasonChange = (event) => {
        setReason(event.target.value);
    };

    const handleCustomReasonChange = (event) => {
        setCustomReason(event.target.value);
    };

    const handleConfirm = () => {
        onConfirm({
            startDate,
            endDate
        });
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle>
                    <Typography variant="h6">Delete Schedule Range</Typography>
                </DialogTitle>
                <Divider />
                <DialogContent className={classes.dialogContent}>
                    <Typography variant="body1" gutterBottom>
                        Please select the date range to remove
                    </Typography>
                    <div className={classes.datePickerContainer}>
                        <DatePicker
                            label="Start Date"
                            value={startDate}
                            onChange={setStartDate}
                            format="yyyy/MM/dd"
                            fullWidth
                            minDate={tomorrow}
                        />
                        <DatePicker
                            label="End Date"
                            value={endDate}
                            onChange={setEndDate}
                            format="yyyy/MM/dd"
                            fullWidth
                            minDate={startDate || tomorrow}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleConfirm} 
                        color="primary" 
                        variant="contained"
                        disabled={!startDate || !endDate}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </MuiPickersUtilsProvider>
    );
} 